import { Controller } from '@hotwired/stimulus'

const BOTTOM_BUFFER = 24 // leave room for the trailing .page__buffer below the grid
const SAFETY = 2 // undershoot a hair so sub-pixel rounding can't tip into an outer scrollbar

export default class extends Controller {
  static targets = ['grid']

  connect() {
    this.adjustHeight()

    // The grid's top isn't final on connect (banners/headers above it settle a frame later, and
    // Turbo renders reconnect without a full reload), so recompute once layout has settled.
    this.frame = requestAnimationFrame(() => this.adjustHeight())

    // Recompute when the scrolling container resizes (window/sidebar). Setting the grid's height
    // changes the container's scrollHeight but not its own box, so there's no feedback loop.
    this.resizeObserver = new ResizeObserver(() => this.adjustHeight())
    this.resizeObserver.observe(this.scrollContainer ?? document.documentElement)
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
    this.resizeObserver.disconnect()
  }

  adjustHeight() {
    const container = this.scrollContainer
    // Fit the grid to the container's visible content area — clientHeight excludes its own
    // horizontal scrollbar — minus the buffer, so it fills the viewport without an outer scrollbar.
    const visibleBottom = container
      ? container.getBoundingClientRect().top + container.clientHeight
      : window.innerHeight
    const available = Math.max(
      350,
      Math.floor(visibleBottom - this.gridTarget.getBoundingClientRect().top) - BOTTOM_BUFFER - SAFETY
    )
    this.gridTarget.style.height = `${available}px`
  }

  get scrollContainer() {
    return this.element.closest('.page__content-container')
  }
}
